import { FormControl, FormHelperText, makeStyles } from "@material-ui/core";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import { useCallback, useState } from "react";
import { useMemo } from "react";
import { useEnumStrings } from "../../enumStrings";
import theme from "../../../themes";
import { sectionInputStyles } from "./sharedInputStyles";

const useStyles = makeStyles(() => ({
  chamberInput: {
    width: "100%",
    marginTop: "2px",
  },
  chamberInputInline: {
    width: "100%",
    marginTop: "2px",
  },
  selectedValue: {
    borderRadius: "15px",
    width: "100%",
    ...sectionInputStyles,
    "& .MuiInputBase-input": {
      fontFamily: "DM Sans, sans-serif",
      fontSize: "16px",
      color: theme.palette.text.primary,
    },
  },
}));

const ProvincePicker = ({
  formikVal,
  formikErrors,
  formikSetFieldValue,
  isOptional = false,
  formikStringError,
  inline = false,
}: {
  formikVal: any;
  formikErrors: any;
  formikSetFieldValue: (a: string, b: boolean | any[]) => void;
  isOptional?: boolean;
  formikStringError: any;
  inline?: boolean;
}) => {
  const classes = useStyles();
  const enumStrings = useEnumStrings();

  const [loading, setLoading] = useState(true);

  const { codeToDropdownOption } = useMemo(() => {
    const codeToDropdownOption = {} as {
      [
      key: string
      ]: typeof enumStrings.provinceDropDownSelect.dropdownOptions[0];
    };
    for (const provinceOption of enumStrings.provinceDropDownSelect
      .dropdownOptions) {
      codeToDropdownOption[provinceOption.code] = provinceOption;
    }

    setLoading(false);
    return { codeToDropdownOption };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleProvinceChange = useCallback(
    (_, selectedDropdownOption) => {
      formikSetFieldValue(
        "address.province",
        selectedDropdownOption ? selectedDropdownOption.code : ""
      );
    },
    [formikSetFieldValue]
  );

  if (loading) {
    return <></>;
  }

  return (
    <FormControl className={inline ? classes.chamberInputInline : classes.chamberInput}>
      <Autocomplete
        id="address.province"
        value={
          formikVal.length === 0
            ? null
            : codeToDropdownOption[formikVal]
        }
        onChange={handleProvinceChange}
        className={classes.selectedValue}
        options={enumStrings.provinceDropDownSelect.dropdownOptions.sort(
          (a, b) => {
            if (a.country === b.country) {
              return a.full.localeCompare(b.full);
            }
            return a.country.localeCompare(b.country);
          }
        )}
        groupBy={(option) => option.country}
        getOptionLabel={(option) => option.full}
        renderInput={(params) => (
          <TextField
            {...params}
            error={formikErrors}
            placeholder={enumStrings.provinceDropDownSelect.SelectProvinceText}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "15px",
                "& fieldset": {
                  borderColor: "black !important",
                  borderRadius: "15px",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#E1A731 !important",
                },
              },
              "& .MuiInputBase-input": {
                fontFamily: "DM Sans, sans-serif",
                fontSize: "16px",
                color: theme.palette.text.primary,
                "&::placeholder": {
                  color: "#333333",
                  opacity: 1,
                },
              },
            }}
          />
        )}
      />
      <FormHelperText
        component="legend"
        style={{
          color: "#f44336",
          paddingLeft: "10px",
          paddingTop: "5px",
          textAlign: "left",
        }}
      >
        {formikErrors ? formikStringError : ""}
      </FormHelperText>
    </FormControl>
  );
};

export default ProvincePicker;
